export default __webpack_public_path__ + "static/media/speak_directly.0e96f0b0.svg";